import {
  runTimeThemeInjection,
  getVendorByHostName,
} from "@sinch-smb/theme-plugin/dist/lib/runtime-theme-injection";

/** Sets up MessageMedia themes based on the origin, or MM if unknown. */
export function setupMessageMediaThemes() {
  runTimeThemeInjection({ staticPath: "/static/themes/runtime" });
}

export function setVendorLabel() {
  // Make it available to the hub...
  window.VENDOR_LABEL = (getVendorByHostName(window.location.origin) ||
    "mm") as Brand;
}
